import { ClassProvider } from '@angular/core';

import { Types } from '../../../domain/types.domain';
import { UseAuthorizationCodeService } from '../../../domain/auth/services/use-authorization-code.service';

export class UseAuthorizationCodeServiceInstruction implements ClassProvider {
  provide = Types.UseAuthorizationCodeService;
  deps = [Types.Settings, Types.AuthRepository];
  useClass = UseAuthorizationCodeService;
} 